// extracted by mini-css-extract-plugin
module.exports = {"text_container":"InstrumentosDisponibles__text_container__1VGT4","main_subtitle":"InstrumentosDisponibles__main_subtitle__3EMgN","slash":"InstrumentosDisponibles__slash__1cXJY"};